import resolver, {ResolverSettings} from './utils/resolver';
import {Paginated, LockReservation, UnlockResponse} from '../utils/types';

class LocksApi {
  ENDPOINTS = {
    get: (params = '') => `locks/?${params}`,
    getOneLock: (id = '', params = '') => `locks/${id}?${params}`,
    unlock: (params = '') => `locks/unlock/?${params}`,
    getOneUnlockLink: (id = '', params = '') => `unlock-links/${id}?${params}`,
    getLocksDetails: (params = '') => `guestapp/locks/?${params}`,
  };

  getLocksDetails(params = '', resolverSettings?: ResolverSettings) {
    return resolver<Paginated<LockReservation>>(
      this.ENDPOINTS.getLocksDetails(params),
      null,
      {
        ...resolverSettings,
        version: 4,
      },
    );
  }

  unlock(params = '', resolverSettings?: ResolverSettings) {
    return resolver<UnlockResponse>(this.ENDPOINTS.unlock(params), null, {
      ...resolverSettings,
    });
  }
}

export {LocksApi};
